import React from 'react';
import { gbTheme, GBTypography } from '@leapfinance/geebee-component-library';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { ThemeProvider } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import classNames from 'classnames';
import { toLower } from 'lodash';
import startCase from 'lodash/startCase';
import { nanoid } from 'nanoid';
var statusTextClassNames = {
    OPEN: 'lfc-text-gbTokens-success-700 lfc-uppercase  lfc-font-semibold'
    // LIKELY_TO_OPEN: 'lfc-text-[#7F572A]'
};
var IntakeChip = function (_a) {
    var groupKey = _a.groupKey, value = _a.value, showInfo = _a.showInfo;
    return (React.createElement("div", { className: ' lfc-mr-2 lfc-flex lfc-items-center lfc-rounded lfc-gap-2 lfc-text=[#1C1C1C]' },
        React.createElement(GBTypography, { variant: groupKey === 'OPEN' ? 'caption2Semibold' : 'body4', className: classNames("lfc-h-fit ".concat(statusTextClassNames[groupKey]), {
                'lfc-text-gbTokens-success-700 lfc-bg-gbTokens-success-200  lfc-p-1 lfc-rounded-sm lfc-mr-1 lfc-normal-case  lfc-font-semibold lfc-text-[12px]': groupKey === 'OPEN',
                'lfc-bg-warning-100': groupKey === 'LIKELY_TO_OPEN'
            }) },
            startCase(toLower(groupKey)),
            ": ",
            '  '), value === null || value === void 0 ? void 0 :
        value.map(function (item, idx) {
            var _a, _b, _c;
            return (React.createElement("div", { key: nanoid() },
                React.createElement(GBTypography, { variant: "body4Semibold", className: " lfc-flex lfc-justify-center lfc-items-center lfc-text-grey-900" },
                    startCase((_a = item === null || item === void 0 ? void 0 : item.month) === null || _a === void 0 ? void 0 : _a.toLowerCase()),
                    " ", item === null || item === void 0 ? void 0 :
                    item.year,
                    showInfo && (item === null || item === void 0 ? void 0 : item.open_date) && (React.createElement(ThemeProvider, { theme: gbTheme },
                        React.createElement(Tooltip, { title: "".concat(startCase(groupKey === null || groupKey === void 0 ? void 0 : groupKey.toLowerCase()), " Date: ").concat((_c = new Date((_b = item === null || item === void 0 ? void 0 : item.open_date) !== null && _b !== void 0 ? _b : '')) === null || _c === void 0 ? void 0 : _c.toDateString()) },
                            React.createElement(InfoOutlined, { fontSize: "small", color: "primary", className: "lfc-ml-1 lfc-h-3 lfc-w-3" })))),
                    idx + 1 !== (value === null || value === void 0 ? void 0 : value.length) && React.createElement(React.Fragment, null, ","))));
        })));
};
export default IntakeChip;
//# sourceMappingURL=IntakeChip.js.map